module.exports = __webpack_public_path__ + "static/DB-a37964f5f61f33b8f01337b199fc50df.jpg";